import { buildReducer } from '../../../shared';
import type DistributionListLoadingState from '../../state/privateDLLoadingState';
import {
    distributionListLoadCompletedAction,
    privateDistributionListNotesLoadCompletedAction,
    distributionListLoadStartAction,
    privateDistributionListNotesLoadStartAction,
} from '../../actions/data/distributionListDataActions';

const defaultState: DistributionListLoadingState = {
    infoAndMembersLoadingState: {},
    notesLoadingState: {},
};

export default buildReducer<DistributionListLoadingState>()
    .handle(distributionListLoadStartAction, (state, action) => {
        return {
            ...state,
            infoAndMembersLoadingState: {
                ...state.infoAndMembersLoadingState,
                [action.payload.hubPersonaId]: { isLoading: true, isError: false },
            },
        };
    })
    .handle(privateDistributionListNotesLoadStartAction, (state, action) => {
        return {
            ...state,
            notesLoadingState: {
                ...state.notesLoadingState,
                [action.payload.hubPersonaId]: { isLoading: true, isError: false },
            },
        };
    })
    .handleDataAction(
        distributionListLoadCompletedAction,
        (state, action) => {
            return {
                ...state,
                infoAndMembersLoadingState: {
                    ...state.infoAndMembersLoadingState,
                    [action.payload.distributionList.hubPersonaId]: {
                        isLoading: false,
                        isError: false,
                    },
                },
            };
        },
        (state, action) => {
            return {
                ...state,
                infoAndMembersLoadingState: {
                    ...state.infoAndMembersLoadingState,
                    [action.payload.hubPersonaId]: { isLoading: false, isError: true },
                },
            };
        }
    )
    .handleDataAction(
        privateDistributionListNotesLoadCompletedAction,
        (state, action) => {
            return {
                ...state,
                notesLoadingState: {
                    ...state.notesLoadingState,
                    [action.payload.hubPersonaId]: { isLoading: false, isError: false },
                },
            };
        },
        (state, action) => {
            return {
                ...state,
                notesLoadingState: {
                    ...state.notesLoadingState,
                    [action.payload.hubPersonaId]: { isLoading: false, isError: true },
                },
            };
        }
    )
    .done(defaultState);
export type { Action } from '../../../shared';
